import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  isMobile,
  isAndroid,
  isChrome,
  isSafari,
  browserVersion,
  osVersion,
} from "react-device-detect";
type Layout = {
  mobile_flag: boolean;
  smallScreen_flag: boolean;
  narrowScreen_flag: boolean; // Used for <Footer>. Otherwise it will unnecessarily change footer's layout
  iOS_flag: boolean;
  iOSNotSafari_flag: boolean;
  notSafari13_flag: boolean; // Some webkit feature only works in Safari 13
  safari_flag: boolean;
  androidNotChrome_flag: boolean;
  brandColor: string;
  secondBrandColor: string;
  backgroundColor: string;
  borderColor: string;
  fontColor: string;
  secondFontColor: string;
  isEmbedding: boolean;
  origin: string;
  isEasterEggModalOpen: boolean;
  isENSRequestModalOpen: boolean;
};

const initialState: Layout = {
  mobile_flag: false,
  smallScreen_flag: false,
  narrowScreen_flag: false,
  iOS_flag: false,
  iOSNotSafari_flag: false,
  notSafari13_flag: false,
  safari_flag: false,
  androidNotChrome_flag: false,
  brandColor: "#1f8feb",
  secondBrandColor: "#1f8feb",
  backgroundColor: "#282c34",
  borderColor: "",
  fontColor: "#ddd",
  secondFontColor: "#aaa",
  isEmbedding: false,
  origin: "",
  isEasterEggModalOpen: false,
  isENSRequestModalOpen: false,
};
export const layoutSlice = createSlice({
  name: "layout",
  initialState,
  reducers: {
    detectBody: (state) => {
      const currentFlag = state.mobile_flag;
      const defaultScreenSize = state.smallScreen_flag;
      const ifSmallScreen = document.body.clientWidth <= 768;
      const ifNarrowScreen = document.body.clientWidth <= 360;
      const nextFlag = isMobile;
      if (currentFlag !== nextFlag) {
        if (isMobile && !isAndroid) {
          state.iOS_flag = true;
        }
        if (isMobile && !isAndroid && parseInt(osVersion) < 14.3 && !isSafari) {
          // iOS support webrtc in webview since 14.3
          state.iOSNotSafari_flag = true;
        }
        if (isMobile && isAndroid && !isChrome) {
          state.androidNotChrome_flag = true;
        }
        state.mobile_flag = nextFlag;
      }
      if (isSafari) {
        if (parseInt(browserVersion) < 13) {
          state.notSafari13_flag = true;
        }
        state.safari_flag = true;
      }
      if (defaultScreenSize !== ifSmallScreen) {
        state.smallScreen_flag = ifSmallScreen;
      }
      if (defaultScreenSize !== ifNarrowScreen) {
        state.narrowScreen_flag = ifNarrowScreen;
      }
      if (window.self !== window.top) {
        state.isEmbedding = true;
      }
    },
    setBrandColor: (state, action: PayloadAction<string>) => {
      state.brandColor = action.payload;
    },
    setBackgroundColor: (state, action: PayloadAction<string>) => {
      state.backgroundColor = action.payload;
    },
    setFontColor: (state, action: PayloadAction<string>) => {
      state.fontColor = action.payload;
    },
    setSecondFontColor: (state, action: PayloadAction<string>) => {
      state.secondFontColor = action.payload;
    },
    setBorderColor: (state, action: PayloadAction<string>) => {
      state.borderColor = action.payload;
    },
    setLayoutOrigin: (state, action: PayloadAction<string>) => {
      state.origin = action.payload;
    },
    setIsEasterEggModalOpen: (state, action: PayloadAction<boolean>) => {
      state.isEasterEggModalOpen = action.payload;
    },
    setIsENSRequestModalOpen: (state, action: PayloadAction<boolean>) => {
      state.isENSRequestModalOpen = action.payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const {
  detectBody,
  setBrandColor,
  setBackgroundColor,
  setFontColor,
  setSecondFontColor,
  setBorderColor,
  setLayoutOrigin,
  setIsEasterEggModalOpen,
  setIsENSRequestModalOpen,
} = layoutSlice.actions;

export default layoutSlice.reducer;
